import { type CurrentTabStorageEvent } from './localStorage.notify.event.d';

import LOCAL_STORAGE_EVENT_KEY from './localStorage.event.key';

import useWindowEvent from '../../useWindowEvent';

type Input = {
  enabled?: boolean;
  localStorageKey: string | null | undefined;
  onEvent: (newValue: string | null) => void;
};

const useSubscribeToStorageEvent = (input: Input) => {
  const { localStorageKey, onEvent, enabled = true } = input;

  const handleCurrentTabEvent = (e: CurrentTabStorageEvent) => {
    if (e.detail.key === localStorageKey) onEvent(e.detail.newValue);
  };

  const handleOtherTabEvent = (e: StorageEvent) => {
    if (e.storageArea !== window.localStorage) return;
    if (e.key === localStorageKey || e.key === null) onEvent(e.newValue);
  };

  const eventOptions = { enabled: enabled && !!localStorageKey };

  useWindowEvent(LOCAL_STORAGE_EVENT_KEY, handleCurrentTabEvent, eventOptions);
  useWindowEvent('storage', handleOtherTabEvent, eventOptions);
};

export default useSubscribeToStorageEvent;
